import { render, staticRenderFns } from "./VueDraggableResizable.vue?vue&type=template&id=01327735&"
import script from "./VueDraggableResizable.vue?vue&type=script&lang=js&"
export * from "./VueDraggableResizable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports